import { NotFoundComponent } from "@website/widget-v2/not-found";
import { HeaderWrapper } from "@website/widget/header-wrapper";
import { GetServerSideProps } from "next";

export default function Custom404() {
  return (
    <div>
      <HeaderWrapper showAuth title="ویلا" showDropShadow={false} />
      <NotFoundComponent />
    </div>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.statusCode = 410;
  return {
    props: {}
  };
};
